export const CATEGORIES = ["Contabilità", "Portafoglio", "Flussi", "Altro"];
export const SUBJECTS = ["Clienti", "Rete Vendita", "Compagnie", "Altro"];

// Tutti gli 8 colori sono DISTINTI tra categorie e soggetti.
export const CATEGORY_COLORS = {
  "Contabilità": "#e8590c", // arancione
  "Portafoglio": "#1971c2", // blu
  "Flussi": "#7c3aed",      // viola
  "Altro": "#495057",       // ardesia
};

export const SUBJECT_COLORS = {
  "Clienti": "#0891b2",      // ciano
  "Rete Vendita": "#2b8a3e", // verde
  "Compagnie": "#c2255c",    // magenta
  "Altro": "#b08900",        // oliva/oro
};

export function categoryColor(c) {
  return CATEGORY_COLORS[c] || "#495057";
}
export function subjectColor(s) {
  return SUBJECT_COLORS[s] || "#b08900";
}

// Category = pastiglia piena; Subject = pastiglia con contorno.
export function TagPill({ label, color, variant = "filled", size = "sm", className = "", ...rest }) {
  if (!label) return null;
  const pad = size === "xs" ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-[11px]";
  const style = variant === "filled"
    ? { background: color, color: "#fff", borderColor: color }
    : { background: "transparent", color, borderColor: color };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-semibold whitespace-nowrap leading-none ${pad} ${className}`}
      style={{ ...style, borderWidth: variant === "filled" ? 0 : 1.5 }}
      {...rest}
    >
      {label}
    </span>
  );
}

export function CategoryPill({ value, ...rest }) {
  if (!value) return null;
  return <TagPill label={value} color={categoryColor(value)} variant="filled" {...rest} />;
}

export function SubjectPill({ value, ...rest }) {
  if (!value) return null;
  return <TagPill label={value} color={subjectColor(value)} variant="outline" {...rest} />;
}

// Due piccoli pallini colorati (categoria pieno, soggetto con contorno) accanto al nome.
export function JobDots({ category, subject, className = "" }) {
  if (!category && !subject) return null;
  return (
    <span className={`inline-flex items-center gap-1 shrink-0 ${className}`}>
      {category && <span title={`Categoria: ${category}`} className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: categoryColor(category) }} />}
      {subject && <span title={`Soggetto: ${subject}`} className="w-2.5 h-2.5 rounded-full shrink-0 border-2 bg-transparent" style={{ borderColor: subjectColor(subject) }} />}
    </span>
  );
}
